import React from 'react';
import { palette } from 'shared/constants/colorsConstants.js';
import { CustomLinkProps } from './types.ts';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';

const CustomLink: React.FC<CustomLinkProps> = ({
  sourceX = 0,
  sourceY = 0,
  sourceControlX = 0,
  targetX = 0,
  targetY = 0,
  targetControlX = 0,
  linkWidth = 1,
  sourceColor = palette.gray[500],
  targetName = '',
  totalTargetValue = 0,
  shouldRenderLabel = false,
  totalCost = 0,
  overrideCurrency = null,
}) => {
  const safeSourceX = isNaN(sourceX) ? 0 : sourceX;
  const safeSourceY = isNaN(sourceY) ? 0 : sourceY;
  const safeSourceControlX = isNaN(sourceControlX) ? 0 : sourceControlX;
  const safeTargetX = isNaN(targetX) ? 0 : targetX;
  const safeTargetY = isNaN(targetY) ? 0 : targetY;
  const safeTargetControlX = isNaN(targetControlX) ? 0 : targetControlX;
  const { getCurrencyNumber } = useUserSettingsContext();

  const percentage = totalCost > 0 && totalTargetValue > 0 ? (totalTargetValue / totalCost) * 100 : 0;

  return (
    <g>
      <path
        d={`
            M${safeSourceX},${safeSourceY + linkWidth / 2}
            C${safeSourceControlX},${safeSourceY + linkWidth / 2}
              ${safeTargetControlX},${safeTargetY + linkWidth / 2}
              ${safeTargetX},${safeTargetY + linkWidth / 2}
            L${safeTargetX},${safeTargetY - linkWidth / 2}
            C${safeTargetControlX},${safeTargetY - linkWidth / 2}
              ${safeSourceControlX},${safeSourceY - linkWidth / 2}
              ${safeSourceX},${safeSourceY - linkWidth / 2}
            Z
          `}
        strokeWidth={linkWidth}
        fill={sourceColor}
      />
      {shouldRenderLabel && (
        <text x={safeTargetX - 10} y={safeTargetY + 5} textAnchor="end" fill={palette.gray[450]} fontSize="12">
          {`${targetName}: ${getCurrencyNumber(totalTargetValue, null, {}, overrideCurrency)}`} {totalCost ? `(${percentage.toFixed(2)}%)` : ''}
        </text>
      )}
    </g>
  );
};

export default CustomLink;
